import React from 'react'
import { useSymbolPrices } from '../../../context/WebSocketContext';
import { OneClickTrading } from '../../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

const BidBuy = ({ symbolId, digits }) => {
    const { [symbolId]: symbol } = useSymbolPrices();
    const { accountId } = useSelector(state => state.accountSummary)

    const buyPoistion = async () => {
        try {
            const payload = {
                accountId: Number(accountId),
                side: 1,
                amount: 1.00,
                symbolId,
                comment: "One-click trading",
            };
            const { data } = await OneClickTrading(payload);
            
            // toast.success(`Trade BUY created successfully!`);
            if (data?.id) {
                const tradeId = data.id;
                const symbolName = symbol?.name;
                const price = data.side === 1 ? symbol?.ask : symbol?.bid;
                const tradeSide = data.side === 1 ? "BUY" : "SELL";

                toast.success(`Trade Opened: ID #${tradeId}, ${symbolName} at ${price ? price.toFixed(symbol?.digits) : "0.00"}, ${tradeSide}, Amount: ${data.amount}`);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Trade execution error");
        }
    }
    return (
        <div className={`border ${symbol?.bidColor == "up" ? "border-green" : "border-red"} flex`}>
            <span className={`${symbol?.bidColor == "up" ? "bgGreen" : "bgRed"} text-white px-2 flex justify-center items-center cursor-pointer `} onClick={buyPoistion}>Buy</span>
            <span className={`text-center px-2 flex items-center justify-center ${symbol?.bidColor == "up" ? "green" : "red"}`}>{symbol?.bid ? (symbol?.bid).toFixed(digits) : '0.00'}</span>
        </div>
    )
}

export default BidBuy